// extracted by mini-css-extract-plugin
export default {"text":"style_text__vsNUm","title":"style_title__o0FZx","textarea":"style_textarea__7uz+V","buttons":"style_buttons__i49kr"};